import React, { Component } from 'react';
import { observer } from 'mobx-react';
import { Row, Col, Button } from 'reactstrap';
import PropTypes from 'prop-types';
import awardeestore from '../stores/awardeestore';

@observer
export default class Confirmation extends Component {

  onClickSubmitAnotherProfile = () => {
    this.props.history.push("/");
    window.location.reload();
  }


  render() {
    const { confirmationId } = awardeestore;

    return(
      <div className="border-form">
          <>
            <Row className="custom-box">
              <Col>
                <div className="center-text">
                  <i className="icon icon-ok-circle check-icon" />
                </div>
                <div className="spacer" />
                <div className="center-text poppinsH5-Confirmation">
                  <b>Confirmation: {confirmationId}</b>
                </div>
                <div className="spacer" />
                <h5 className="center-text confirmationTitle poppinsH5-ThankYouNote mt-20">
                  {`The AHAH Awardee Profile has been successfully submitted. If you have questions about an awardee's AHAH Rental `}
                </h5>
                <div className="spacer" />
                <h5 className="center-text poppinsH5-ThankYouNote">
                  Assistance Program voucher, please email us at 
                  (<a className='upload_voucher_link' href={`mailto:AHAH@wellpoint.com`}>AHAH@wellpoint.com</a>) 
                  or call 1-844-451-2828.
                </h5>
                <div className="spacer" />
              </Col>
            </Row>
            <Row>
              <Col className='flexJustifyAround'>
                <Button color={"primary"} style={{alignItems: 'center'}} className={'btn btn-primary awardeeNextBtn mt-40'} onClick={this.onClickSubmitAnotherProfile}>
                  Submit Another AHAH Awardee Profile
                </Button>
              </Col>
            </Row>
          </>
      </div>
    );
  }
}

Confirmation.propTypes = {
  history: PropTypes.object
};